import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { APP_ROUTING } from './app.routes';
import { AppComponent } from './app.component';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER } from '@angular/core';
import { AppConfig } from './app.config';
import localeEs from '@angular/common/locales/es';
import { registerLocaleData, DatePipe } from '@angular/common';
registerLocaleData(localeEs);
import {FlexLayoutModule} from '@ngbracket/ngx-layout';

// Material animation -- Optional
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './modules/shared/auth/token-interceptor';
import { MsjDescriptionPipe } from './modules/shared/pipes/msj-description.pipe';
import { DialogModule } from './modules/shared/errorHandler/dialog.module';
import { FileDocumentViewModalModule } from './modules/shared/file-document-view-modal/file-document-view-modal.module';
import { FileDocumentMetadataModule } from './modules/shared/file-document-metadata/file-document-metadata.module';
import { AddMenuDialogModule } from './modules/employer/add-menu-dialog/add-menu-dialog.module';
import { AddMetadataValueDialogModule } from './modules/employer/add-metadata-value-dialog/add-metadata-value-dialog.module';
import { EditMetadataValueDialogModule } from './modules/employer/edit-metadata-value-dialog/edit-metadata-value-dialog.module';
// MultipleDocumentationAddDialogModule moved to CandidateFindModule (lazy) to keep @formio/js out of initial bundle
import { DocumentationTypeSetConfigurationDialogModule } from './modules/employer/documentation-type-set-configuration-dialog/documentation-type-set-configuration-dialog.module';
import { ViewFileModalModule } from './modules/employer/view-file-modal/view-file-modal.module';
import { CreateLsdModule } from './modules/employer/create-lsd/create-lsd.module';
import { HotjarModule } from './modules/hotjar/hotjar.module';
import {AddLeaveDialogComponent } from './modules/employee/add-leave-dialog/add-leave-dialog.component';
import { AddTimeLineDialogModule } from './modules/employer/add-dialog-timeLines/add-dialog-time-lines.module';
import { AddHolidayDialogComponent } from './modules/employer/add-dialog-holiday/add-dialog-holiday.component';
import { ProgressMassiveApproveRequestsModule } from './modules/employer/progress-massive-approve-requests/progress-massive-approve-requests.module';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { LocalizedLuxonDateModule } from './core/i18n/localized-date-adapter';
import { MY_DATE_FORMATS } from './modules/shared/models/date-formats';
import { CreateYearDialogModule } from './modules/employer/create-year-dialog/create-year-dialog.module';
import { CentralRouterService } from './core/microfrontends/routing/central-router.service';
import { MicrofrontendEventsService } from './core/microfrontends/microfrontend-events/microfrontend-events.service';
import { MicrofrontendActionsService } from './core/microfrontends/microfrontend-actions/microfrontend-actions.service';
import { TranslocoRootModule } from './core/i18n/transloco-root.module';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ShellOverlayContainer } from './modules/shared/overlay/shell-overlay-container';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

export function initializeCentralRouter(centralRouter: CentralRouterService) {
  return () => centralRouter.load();
}

export function initializeMicrofrontendListener(listener: MicrofrontendEventsService) {
  return () => listener.load();
}

export function initializeMicrofrontendActions(actions: MicrofrontendActionsService) {
  return () => actions.load();
}

@NgModule({
    declarations: [
    AppComponent
  ],
    imports: [
    BrowserModule,
    HttpClientModule,
    APP_ROUTING,
    BrowserAnimationsModule,
    FlexLayoutModule,
    DialogModule,
    FileDocumentViewModalModule,
    FileDocumentMetadataModule,
    AddMenuDialogModule,
    AddLeaveDialogComponent,
    AddMetadataValueDialogModule,
    EditMetadataValueDialogModule,
    DocumentationTypeSetConfigurationDialogModule,
    ViewFileModalModule,
    CreateLsdModule,
    HotjarModule,
    AddTimeLineDialogModule,
    AddHolidayDialogComponent,
    CreateYearDialogModule,
    ProgressMassiveApproveRequestsModule,
    LocalizedLuxonDateModule,
    TranslocoRootModule
  ],
    providers: [
        AppConfig,
        { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfig], multi: true },
        { provide: APP_INITIALIZER, useFactory: initializeCentralRouter, deps: [CentralRouterService], multi: true },
        { provide: APP_INITIALIZER, useFactory: initializeMicrofrontendListener, deps: [MicrofrontendEventsService], multi: true },
        { provide: APP_INITIALIZER, useFactory: initializeMicrofrontendActions, deps: [MicrofrontendActionsService], multi: true },
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
        { provide: OverlayContainer, useClass: ShellOverlayContainer },
        { provide: LOCALE_ID, useValue: 'es', deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        MsjDescriptionPipe,
        DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
